var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDeviceClientOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 17.9688C12.4219 16.8642 13.3173 15.9688 14.4219 15.9688H50.4219C51.5264 15.9688 52.4219 16.8642 52.4219 17.9688V42.9688H12.4219V17.9688Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 18.9687C14.5781 18.4165 15.0258 17.9688 15.5781 17.9688H49.5781C50.1304 17.9688 50.5781 18.4165 50.5781 18.9688V40.9688H14.5781V18.9687Z",
    fill: "url(#paint0_linear_974_10500)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5582 43.0215H52.2855L55.4219 45.0215H9.42188L12.5582 43.0215Z",
    fill: "url(#paint1_linear_974_10500)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42188 45.0737H55.4219V47.0737C55.4219 47.626 54.9742 48.0737 54.4219 48.0737H10.4219C9.86959 48.0737 9.42188 47.626 9.42188 47.0737V45.0737Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5781 29.0313C45.5781 27.3744 46.9213 26.0312 48.5781 26.0312H57.5781C59.235 26.0312 60.5781 27.3744 60.5781 29.0312V51.0312C60.5781 52.6881 59.235 54.0312 57.5781 54.0312H48.5781C46.9213 54.0312 45.5781 52.6881 45.5781 51.0312V29.0313Z",
    fill: "url(#paint2_linear_974_10500)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.5781 27.0312H48.5781C47.4736 27.0312 46.5781 27.9267 46.5781 29.0313V51.0312C46.5781 52.1358 47.4736 53.0312 48.5781 53.0312H57.5781C58.6827 53.0312 59.5781 52.1358 59.5781 51.0312V29.0312C59.5781 27.9267 58.6827 27.0312 57.5781 27.0312ZM48.5781 26.0312C46.9213 26.0312 45.5781 27.3744 45.5781 29.0313V51.0312C45.5781 52.6881 46.9213 54.0312 48.5781 54.0312H57.5781C59.235 54.0312 60.5781 52.6881 60.5781 51.0312V29.0312C60.5781 27.3744 59.235 26.0312 57.5781 26.0312H48.5781Z",
    fill: "#4C4C4C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0781 28C51.0781 27.7239 51.302 27.5 51.5781 27.5H54.5781C54.8543 27.5 55.0781 27.7239 55.0781 28C55.0781 28.2761 54.8543 28.5 54.5781 28.5H51.5781C51.302 28.5 51.0781 28.2761 51.0781 28Z",
    fill: "#4C4C4C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 17,
    r: 5,
    fill: "#00B61B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_974_10500",
    x1: 32.5781,
    y1: 17.9687,
    x2: 32.5781,
    y2: 40.9687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDE4FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_974_10500",
    x1: 32.9219,
    y1: 43.0215,
    x2: 32.9219,
    y2: 45.5215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_974_10500",
    x1: 53.0781,
    y1: 26.0312,
    x2: 53.0781,
    y2: 54.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAE3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeviceClientOn);
export default __webpack_public_path__ + "static/media/img_device_client_on.c8233ffcea0206399fe91fa8b5014261.svg";
export { ForwardRef as ReactComponent };